import { configureStore } from "@reduxjs/toolkit";
import RegisterReducer from "./register";
import HomeReducer from "./home";
import NewsReducer from "./news";
import CompanyReducer from "./company";

const store = configureStore({
	reducer: {
		register: RegisterReducer,
		home: HomeReducer,
		news: NewsReducer,
		company: CompanyReducer,
	},
});

export default store;
